<app-transaction-criteria-form (criteria)="onSearch($event)"></app-transaction-criteria-form>
<app-transaction-list [sorting]="sorting" (sort)="onSort($event)"></app-transaction-list>
